import baseURL from '../common/axios';
import { value } from 'dom7';
class StockReasonservice {

    //Create API -> To Create Master
    createdata(form) {
        return baseURL.httpMSInventoryUrl.post("StockReasonMAS/Create", form)
    }
    //Get List API -> To Show Table Values
    getlistdata() {
        return baseURL.httpMSInventoryUrl.get("StockReasonMAS/List")
    }
    //Update API -> To Update Values in Form
    updatedata(form) {
        return baseURL.httpMSInventoryUrl.post("StockReasonMAS/Update", form)
    }
    //Get API -> To Get Values from Table
    getdata(form) {
        return baseURL.httpMSInventoryUrl.get("StockReasonMAS/Get?id=" + form)
    }
    //Delete -> To Delete Values from Table
    deletedata(form) {
        return baseURL.httpMSInventoryUrl.delete("StockReasonMAS/Delete?id=" + form)
    }
    //Active
    active(form, Status) {
        return baseURL.httpMSInventoryUrl.put("StockReasonMAS/Active?id=" + form + "&Status=" + Status)
    }
}
export default new StockReasonservice()